import React from 'react';
import { Loader2 } from 'lucide-react';

export interface ProcessLoadingScreenProps {
  isVisible: boolean;
  title: string;
  description: string;
  steps: string[];
  currentStep: number;
}

const ProcessLoadingScreen: React.FC<ProcessLoadingScreenProps> = ({
  isVisible,
  title,
  description,
  steps,
  currentStep
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-8 max-w-md w-full mx-4 shadow-xl">
        <div className="text-center">
          <div className="mb-6">
            <Loader2 className="h-12 w-12 animate-spin text-accent-600 dark:text-accent-400 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-windows-900 dark:text-windows-100 mb-2">{title}</h3>
            <p className="text-windows-600 dark:text-windows-400">{description}</p>
          </div>
          
          <div className="space-y-3">
            {steps.map((step, index) => (
              <div key={index} className="flex items-center space-x-3">
                <div className={`w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 ${
                  index === currentStep 
                    ? 'bg-accent-600 dark:bg-accent-500 text-white animate-pulse' 
                    : index < currentStep
                    ? 'bg-accent-400 dark:bg-accent-600 text-white'
                    : 'bg-windows-200 dark:bg-gray-700 text-windows-600 dark:text-gray-300'
                }`}>
                  <span className="text-xs font-medium">{index + 1}</span>
                </div>
                <span className={`text-sm transition-all duration-300 ${
                  index === currentStep ? 'text-windows-900 dark:text-windows-100 font-medium' : 'text-windows-600 dark:text-windows-400'
                }`}>
                  {step}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessLoadingScreen;

